export default __webpack_public_path__ + "static/media/comedora-producto-champinon-league.5ce86008.png";